export const forceAbsoluteStrapiUrl = (url?: string) => {
  if (!url) {
    return undefined;
  }

  if (url.startsWith('/')) {
    url = `${process.env.NEXT_PUBLIC_STRAPI_URL}${url}`;
  }

  return url;
};
